export class HttpService {
    constructor(baseUrl, autorizationService) {
        this.baseUrl = baseUrl;
        this.autorizationService = autorizationService;
    }
    async get(path, params) {
        const request = new Request(this.createUrl(path, params));
        this.authorize(request);
        return fetch(request);
    }
    async post(path, body, params) {
        const request = new Request(this.createUrl(path, params), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        this.authorize(request);
        return fetch(request);
    }
    async put(path, body, params) {
        const request = new Request(this.createUrl(path, params), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        this.authorize(request);
        return fetch(request);
    }
    async delete(path, params) {
        const request = new Request(this.createUrl(path, params), {
            method: 'DELETE'
        });
        this.authorize(request);
        return fetch(request);
    }
    createUrl(path, params) {
        if (params) {
            path += `?${params}`;
        }
        return new URL(path, this.baseUrl).toString();
    }
    authorize(request) {
        if (!this.autorizationService.hasToken.value) {
            return;
        }
        request.headers.set('Authorization', `Bearer ${this.autorizationService.getToken()}`);
    }
}
